module.exports = __webpack_public_path__ + "img/social.690d01d6.png";